






























import { Component, Prop, Mixins } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IClient, IClientForm } from "@/models/clients";
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";

@Component({
  components: {
    "create-password": () =>
      import("@/components/app/global/fields/createPasswordField.vue")
  }
})
export default class SetPasswordModal extends Mixins(
  RequestPromises,
  HasValidation
) {
  // Props
  @Prop({ required: true })
  public clientId!: IClient["id"];

  // Data
  public form: Pick<IClientForm, "password"> = { password: "" };
  public isLoading = false;
  public isProcessing = false;

  // Computed

  public get isFormDisabled() {
    return (
      this.hasErrors || this.$_.isEmpty(this.form.password) || this.isProcessing
    );
  }

  // Methods

  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");
      this.isProcessing = true;
      await this.$store.dispatch(`data/${DataModules.CLIENTS}/update`, {
        id: this.clientId,
        data: this.form,
        vm: this
      });
      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.client_password_changed")
      });
      this.$emit("success");
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
